declare global {
  interface RouterMeta {
    title: string;
  }
  interface Router {
    path: string;
    name: string;
    icon?: string;
    permission?: string;
    meta?: RouterMeta;
    component: any;
    props?: Boolean;
    children?: Array<Router>;
  }
  interface System {
    import(request: string): Promise<any>;
  }
  let System: System;
}
import login from "../views/login.vue";
import main from "../views/main.vue";

export const loginRouter: Router = {
  path: "/",
  name: "login",
  meta: {
    title: "LogIn"
  },
  component: login
};

export const otherRouters: Router = {
  path: "/main",
  name: "main",
  permission: "",
  meta: { title: "ManageMenu" },
  component: main,
  children: []
};

export const launchpadRouters: Router = {
  path: "/home",
  name: "home",
  meta: { title: "Home" },
  component: () => import("../components/master/master.vue"),
  children: [
    { path: "FreeTrial", meta: { title: "Free Trial" }, name: "freeTrialConsole", props: true, component: () => import("../views/freeTrialConsole.vue") },
    { path: "Churn", meta: { title: "Churn" }, name: "churn", props: true, component: () => import("../views/churn.vue") }
  ]
};

export const appRouters: Array<Router> = [
  {
    path: "/setting",
    name: "setting",
    permission: "",
    meta: { title: "ManageMenu" },
    icon: "&#xe68a;",
    component: main,
    children: [
      {
        path: "appUser",
        permission: "Pages.Users",
        meta: { title: "Users" },
        name: "appUser",
        component: () => import("../views/setting/user/user.vue")
      },
      {
        path: "role",
        permission: "Pages.Roles",
        meta: { title: "Roles" },
        name: "role",
        component: () => import("../views/setting/role/role.vue")
      },
      {
        path: "tenant",
        permission: "Pages.Tenants",
        meta: { title: "Tenants" },
        name: "tenant",
        component: () => import("../views/setting/tenant/tenant.vue")
      }
    ]
  }
];
export const routers = [loginRouter, ...appRouters, otherRouters, launchpadRouters];
